/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ClaimsSchemaFieldLinkValueLinkType: core.serialization.Schema<
    serializers.ClaimsSchemaFieldLinkValueLinkType.Raw,
    Truvity.ClaimsSchemaFieldLinkValueLinkType
> = core.serialization.enum_(['REFERENCE']);

export declare namespace ClaimsSchemaFieldLinkValueLinkType {
    export type Raw = 'REFERENCE';
}
